import { format } from 'date-fns'
import { object, bool } from 'prop-types'
import { kuiperClassNames } from '@opallabs/kuiper'
import './styles.scss'

const DropWarner = ({ date, isNotWithinStory, story }) => {
  const message = isNotWithinStory
    ? `Outside story date range!
        ${format(
          story.scheduled_start_at,
          'MMM dd, yyyy'
        )} - ${format(story.scheduled_end_at, 'MMM dd, yyyy')}`
    : `This moment is already scheduled for ${format(date, 'MMM dd, yyyy')}`

  return (
    <div className={kuiperClassNames('dropWarner', { isNotWithinStory })}>
      {message}
    </div>
  )
}

DropWarner.propTypes = {
  date: object,
  isNotWithinStory: bool,
  story: object,
}

export default DropWarner
